/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
// src/components/PartenairesAccordion.jsx
import React, { useState } from 'react';
import Curieux              from './Curieux';
import ApporteurAffaires    from './ApporteurAffaires';
import BesoinEntreprise     from './BesoinEntreprise';
import PorteurProjet        from './PorteurProjet';
import SavoirFaire          from './SavoirFaire';
import RechercheFinancement from './RechercheFinancement';

const items = [
    {key: 'curieux', title: 'Je suis un curieux', Component: Curieux},
    {key: 'apporteurs', title: 'Je suis un apporteur d’affaire', Component: ApporteurAffaires},
    {key: 'besoins', title: 'J’ai un besoin pour mon entreprise', Component: BesoinEntreprise},
    {key: 'innovations', title: 'Je suis porteur d’un projet innovant', Component: PorteurProjet},
    {key: 'savoir', title: 'Je veux proposer mon savoir-faire', Component: SavoirFaire},
    {key: 'financements', title: 'Je souhaite financer des projets innovants...', Component: RechercheFinancement}
];

export default function PartenairesAccordion() {
    const [openKey, setOpenKey] = useState(null);

    const toggle = key => {
        const newKey = openKey === key ? null : key;
        setOpenKey(newKey);

        if (newKey !== null) {
            notifyServer(newKey);
        }
    };

    const notifyServer = async key => {

      
        /*
         alert(`Accordion ouvert : ${key}`);
         */

        /*
         try {
         await fetch('https://tonserveur.com/api/accordion-opened', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({
         key,
         timestamp: new Date().toISOString(),
         userAgent: navigator.userAgent,
         location: window.location.href,
         }),
         });
         } catch (err) {
         console.error('Erreur de notification :', err);
         }
         
         */
    };


    return (
            <section className="reasons">
                <div className="main-box">
                    Je souhaite participer parce que :
                </div>
            
                <div className="accordion">
                    {items.map(({ key, title, Component }) => {
                                    const isOpen = openKey === key;
                                    return (
                                        <div key={key} className="accordion__item">
                                            <div
                                                className="accordion__header"
                                                onClick={() => toggle(key)}
                                                >
                                                <span>{title}</span>
                                                <span className={`accordion__icon ${isOpen ? 'open' : ''}`}>
                                                    {isOpen ? '−' : '+'}
                                                </span>
                                            </div>
                                            {isOpen && (
                                                                        <div className="accordion__content">
                                                                            <Component />
                                                                        </div>
                                                                )}
                                        </div>
                                            );
                                })}
                </div>
                        <i>Information importante : Dans un objectif d'amélioration continue et d'analyse, nous pouvons analyser l'ouverture des différentes options à des fins statistiques.</i>
            </section>
            );
}
